/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import {getHost, reduceParams, parseParams, querystring} from '@ywfe/utils';



  const {basePath = '', loginPath = ''} = getHost("PROAUTH", "446")



  
    
      export interface API48196Item {
        
      /** 任务idY */
      id?: number;
        
      /** 任务标题 */
      taskTitle?: string;
        
      /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
      taskStatus?: number;
        
      /** 任务执行人id */
      executorId?: string;
        
      /** 任务执行人姓名 */
      executorName?: string;
        
      /** <pre>,执行人的任务处理状态(1:未开始;2:进行中;3:已关闭;5:已完成),详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
      executorTaskStatus?: number;
        
      /** 任务创建类型(1:人工创建,2:系统创建),详见TaskCreateTypeEnum */
      createType?: number;
        
      /** 任务创建类型描述 */
      createTypeDesc?: string;
        
      /** 业务域(1:自定义,2:直播,3:商家,4:内控,5:大数据,6:粉丝，默认自定义),详见BizDomainEnum */
      bizDomain?: number;
        
      /** 任务执行者姓名列表 ,String */
      executorNameList?: string[];
        
      /** 任务发起者姓名 */
      creatorName?: string;
        
      /** 计划开始时间yyyy-MM-ddHH:mm */
      startTime?: any;
        
      /** 计划完成时间yyyy-MM-ddHH:mm */
      endTime?: any;
        
      /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
      taskPriority?: number;
        
      /** 优先级描述 */
      taskPriorityDesc?: string;
        
      /** 逾期标签(1:正常,2:逾期),详见OverdueEnum,@seecom.ywwl.foundation.teamwork.client.enums.OverdueEnum */
      overdueTag?: number;
        
      /** 任务评级(1~5) */
      evaluateLevel?: number;
        
      };
    
  



  export interface API48196Req {
  
      /** 任务查询类型(0:我执行的任务,1:我发起的任务,2:抄送我的任务) */
      queryType?: string;
    
      /** 任务标题 */
      taskTitle?: string;
    
      /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
      taskPriority?: string;
    
      /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
      taskStatus?: string;
    
      /** 任务执行人id */
      executorId?: string;
    
      /** 抄送人id */
      taskCCId?: string;
    
      /** 任务发起人Id */
      creator?: string;
    
      /** 开始时间yyyy-MM-ddHH:mm:ss */
      startTime?: string;
    
      /** 完成时间yyyy-MM-ddHH:mm:ss */
      endTime?: string;
    
      /** 排序字段 */
      orderFiled?: string;
    
      /** 排序类型(0:降序,1:升序) */
      orderType?: string;
    
      /**  */
      pageSize?: string;
    
      /**  */
      pageIndex?: string;
    
      /**  */
      rowId?: string;
    
      /**  */
      jumpType?: string;
    
      /**  */
      searchCount?: string;
    
      /**  */
      orderObjects?: string;
    
  };



  export interface API48196Res {
    /** T  */
    list?: API48196Item[];
    /**   */
    totalNumber?: any;
    /**   */
    totalPage?: any;
    /**   */
    rowId?: string;
    /**   */
    hasNext?: boolean;
    /**   */
    pageSize?: any;
    /**   */
    pageIndex?: any;
    
  };


// 48196 分页查询任务

export const useGetAPI48196 = () => {
  let isMount = true;
  const [isAPI48196Loading, setIsAPI48196Loading] = useState(false);
  const [dataAPI48196, setDataAPI48196] = useState<API48196Res>({} as API48196Res);
  const fetchAPI48196Data = async (inputs: API48196Req, config?: YWRequestConfig): Promise<API48196Res> => {
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48196Req>) || {}) as API48196Req;
    
    if ( isMount ) {
      setIsAPI48196Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48196Res>(`${basePath}/workTask/pageQueryWorkTask?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48196(res || {} as API48196Res);
        setIsAPI48196Loading(false);
      }
      return res;
    } catch (error) {
      console.error('API error: ', error);
      if ( isMount ) {
        setIsAPI48196Loading(false);
      }
      return false as unknown as API48196Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48196Loading,
    dataAPI48196,
    fetchAPI48196Data,
  }
}

